// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "6ee7626",
    "hash": "6ee7626",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "6ee7626",
    "semverString": null,
    "version": "1.12.0",
    "time": 1774415830903
};
/* tslint:enable */
